"use client";
/**
 * @description: 筛选组件选择组件，重构自老项目
 */
import React from "react";
import styles from "./filterCheckBox.module.scss";
import classNames from "classnames";
import { FmIcon, FmImage } from "@/ui-component";

type FilterCheckBoxProps = {
    title?: string;
    id?: number;
    img?: string;
    imgW?: number;
    imgH?: number;
    checked: boolean;
    onChange: Function;
    type?: number;
    className?: string;
    disable?: boolean;
};

const FilterCheckBox = (props: FilterCheckBoxProps) => {
    const {
        title = "",
        id = 0,
        img = "",
        checked,
        imgW,
        onChange,
        type = 1,
        disable,
        className,
    } = props;
    return (
        <div
            className={classNames(
                styles[`radio-container`],
                styles[className || ""],
            )}
            onClick={() => {
                onChange && onChange(id);
            }}
        >
            {checked && (
                <div
                    className={classNames({
                        [styles["radio-box-checked"]]: type === 1,
                        [styles["radio-box-checked-2"]]: type !== 1,
                        [styles["radio-box-disable"]]: disable,
                    })}
                >
                    <FmIcon
                        icon="icon--checked"
                        style={{
                            fontSize: "0.28rem",
                            fontFamily: "var(--font-montserrat-bold)",
                            color: `${
                                disable
                                    ? "#fff"
                                    : type === 1
                                      ? "#fff"
                                      : "#5EB5EF"
                            }`,
                        }}
                    />
                </div>
            )}
            {!checked && (
                <div
                    className={classNames(styles["radio-box"], {
                        [styles["radio-box-disable"]]: disable,
                    })}
                />
            )}
            {img && (
                <FmImage
                    width={60}
                    height={20}
                    image={img}
                    className={styles["radio-img"]}
                    style={{ width: `${imgW ? imgW : 0}rem` }}
                />
            )}
            <p className={styles["radio-title"]}>{title}</p>
        </div>
    );
};

export default FilterCheckBox;
